import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UnitsService } from 'src/app/services/units.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe ,Location } from '@angular/common';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {

  validForm = true
  unitId: any
  clientForm: FormGroup | any
  types_arr: any
  relion_arr = ["Husband","Wife",'Son',
  "Daughter","Grandfather","Grandmother",
  "Grandson","Mother-in-law","Father-in-law",
  "Step-mother","Stepfather","Brother","Sister",
  "Paternal Aunt (Father's sister)" ,
   "Paternal Uncle (Father's brother)", "Half-brother" , "Stepsister"]
  typeName: any = "Relation type"
  typeId: any = ""
  submitted = false;
  clientId: any
  userPhotoPath: any = ""
  pipe = new DatePipe('en-US');
  userEditPhtot = false
  url: any
  docmentImage: any = []
  userDocEditPhtot = false
  docmentsFiles:any = []
  Relation = "Relation"

  constructor(private formBuilder: FormBuilder,
    private activeRouter: ActivatedRoute,
    private route : Router,
    private mainservice: MainService,
    private location: Location,
    private rest: UnitsService) { }

  ngOnInit() {
    this.unitId = this.activeRouter.snapshot.paramMap.get('id');
    this.initForm()
    this.unitRetalitonType()
  }

  initForm() {
    this.clientForm = this.formBuilder.group(
      {
        name: ['', Validators.required],
        valid_from: ['', Validators.required],
        national_id: ['', Validators.required],
        arabic_name: ['', Validators.required],
        valid_to: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        birth_date: ['', Validators.required],
        gender: ['', Validators.required],
        phone_number: ['', Validators.required],
        verified: [''],
        activated: [''],
      })
  }

  get ControlForm() { return this.clientForm.controls; }

  nextDataInForm() {
    // this.validForm = false
    this.submitted = true;
    if (this.clientForm.valid && this.typeId != '') {
      let formValue = this.clientForm.value
      formValue.birth_date = this.pipe.transform(formValue.birth_date, 'YYYY-MM-dd');
      formValue.valid_from = this.pipe.transform(formValue.valid_from, 'YYYY/MM/dd');
      formValue.valid_to = this.pipe.transform(formValue.valid_to, 'YYYY/MM/dd');

      let data_step_one = formValue
      data_step_one.unit_id = this.unitId
      data_step_one.unit_relation_id = this.typeId
      if(this.typeName != "Owne"){
        data_step_one.relation = this.typeName

      }else {
        data_step_one.relation = this.Relation

      }
      
      
      this.rest.addClient(data_step_one).subscribe((res: any) => {
        console.log(res)
        this.clientId = res
        this.validForm = false
      })
    }
    console.log(this.clientForm.value)
  }

  unitRetalitonType() {
    this.rest.unitRelation().subscribe((res: any) => {
      console.log(res)
      this.types_arr = res.children
    })
  }

  getRelationTypeId(value: any) {
    this.typeName = value.name
    this.typeId = value.id
  }

  getRelationName(value: any) {
    this.Relation = value
  }

  // docemnts
  uploadDocmentsClient(event: any) {
    this.userDocEditPhtot = true
    console.log(event.target.files)
    let files: any = event.target.files
    for (let i = 0; i < files.length; i++) {
      this.docmentsFiles.push({
        type :this.typeDocName + i ,
        path : files[i]
      })
      this.convertFile(files[i])
    }
    console.log(this.docmentImage)
  }

  convertFile(file:any) {
    if(file.type == "application/pdf"){
      if(this.typeDocName == "Other"){
        this.typeDocName = this.typeInputName
      }
      this.docmentImage.push({
        url : file.name,
        file : true,
        fileName : file.name,
        name:this.typeDocName
      });
    }else {
      if(this.typeDocName == "Other"){
        this.typeDocName = this.typeInputName
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (_event) => {
        this.docmentImage.push({
          url : reader.result,
          file : false,
          fileName : file.name,
          name:this.typeDocName
        });
      }
    } 
    this.erorrDocmentPhoto = false
  }

  removeDocImage(item:any){
    console.log(item)
    for(let i = 0 ; i < this.docmentImage.length;i++){
      if(this.docmentImage[i].fileName == item.fileName){
        this.docmentImage.splice(i,1) 
      }
    }
    for(let i = 0 ; i < this.docmentsFiles.length;i++){
      console.log(this.docmentsFiles[i])
      if(this.docmentsFiles[i].path.name == item.fileName){
        console.log(this.docmentsFiles[i])
        this.docmentsFiles.splice(i,1) 
      }
    }
    if(this.docmentsFiles.length == 0){
      this.userDocEditPhtot = false
      this.erorrDocmentPhoto = true
    }


    console.log(this.docmentsFiles)
  }

 typeDocName:any  = "ID_Passport"
 typeInputName:any = ''
 status_input_type_name = false
  typechoose(e:any){
    if(e == "Other"){
      this.status_input_type_name = true
    }else {
      this.status_input_type_name = false
      this.typeDocName = e
    }
  }

  // end docments

  

  // user photo

  uploadUserPhoto(event: any) {
    this.userEditPhtot = true
    this.userPhotoPath = event.target.files[0]
    const reader = new FileReader();
    let imagePath = this.userPhotoPath;
    reader.readAsDataURL(imagePath);
    reader.onload = (_event) => {
      this.url = reader.result;
      this.erorrUserPhoto = false
    }
  }
  removeUserImage() {
    this.userPhotoPath = ""
    this.userEditPhtot = false
    this.erorrUserPhoto = true
  }

  // end user photo

  erorrUserPhoto = false
  erorrDocmentPhoto = false
  createClient() {
    if(this.userPhotoPath == ""){
     this.erorrUserPhoto = true
    }
    if(this.docmentsFiles.length == 0){
      this.erorrDocmentPhoto = true
    }

    if(this.userPhotoPath == "" || this.docmentsFiles.length == 0 ){
      return
    }else {
      this.docmentsFiles.push({
        type : "personal_photo",
        path : this.userPhotoPath
      })
      console.log(this.docmentsFiles)
  
      this.rest.addClientImage(this.clientId, this.docmentsFiles)
        .then((response: any) => response.text())
        .then((result: any) => {
          this.mainservice.SuccessToast("Client Created")
          this.back()
          console.log(result)
        })
        .catch((error: any) => {
        });
    }
    
  }

  inputChange(e:any){
    console.log(e.target.value)
    this.typeDocName = e.target.value
  }

  back(){
    this.location.back();
  }

}
